import React, { useState, useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import './index.scss';
import { apiHolder as api, apis } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const systemApi = api.api.getSystemApi();
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const UpgradeMeansModal = ({ visible, onClose }) => {
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [allowClearByName, setAllowClearByName] = useState(false);
    const [allowClearByMoblie, setAllowClearByMoblie] = useState(false);
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            console.log('Success:', values);
            if (values.nickName.trim().length === 0 || values.mobile.trim().length === 0) {
                SiriusMessage.error({
                    content: getIn18Text('QINGSHURUXINGMING11'),
                });
                return;
            }
            setConfirmLoading(true);
            let params = form.getFieldsValue();
            productAuthApi
                .createPubClue(Object.assign(Object.assign({}, params), { contactRole: '1', subOrigin: getIn18Text('YOUJIANZHUIZONGXU') }))
                .then(res => {
                if (res.code === 200) {
                    onClose('success');
                    productAuthApi.savePubClueTime().then();
                }
                else {
                    SiriusMessage.error({
                        content: getIn18Text('TIJIAOSHIBAI'),
                    });
                }
            })
                .catch(() => {
                SiriusMessage.error({
                    content: getIn18Text('WANGLUOSHIBAI\uFF0C'),
                });
            })
                .finally(() => {
                setConfirmLoading(false);
            });
        }
        catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
    const renderTitle = (React.createElement("div", null,
        React.createElement("div", { className: "upgrade-title" }, getIn18Text('SHENGJIZILIAOTIAN')),
        React.createElement("div", { className: "upgrade-describe" }, getIn18Text('SHENGJIFUWUTAO11'))));
    useEffect(() => {
        const { nickName, mobile } = systemApi.getCurrentUser();
        form.setFieldsValue({
            nickName: nickName || '',
            mobile: mobile || '',
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { className: "upgradeModel", title: renderTitle, width: 480, visible: visible, maskClosable: false, okText: getIn18Text('TIJIAO'), confirmLoading: confirmLoading, cancelText: getIn18Text('FANGQI'), destroyOnClose: true, onOk: handleOk, onCancel: () => onClose() },
            React.createElement(Form, { form: form, name: "basic", labelCol: { span: 5 }, wrapperCol: { span: 19 }, initialValues: { name: '', mobile: '' }, autoComplete: "off", labelAlign: "left" },
                React.createElement(Form.Item, { label: getIn18Text('XINGMING'), name: "nickName", rules: [
                        { required: true, message: getIn18Text('QINGSHURUXINGMING') },
                        { type: 'string', max: 25, message: getIn18Text('XINGMINGBUNENGCHAO') },
                    ] },
                    React.createElement(Input, { allowClear: allowClearByName, placeholder: getIn18Text('QINGSHURUXINGMING'), onBlur: () => {
                            allowClearByName && setAllowClearByName(false);
                        }, onFocus: () => {
                            !allowClearByName && setAllowClearByName(true);
                        } })),
                React.createElement(Form.Item, { label: getIn18Text('LIANXIFANGSHI'), name: "mobile", rules: [{ required: true, message: getIn18Text('QINGSHURULIANXI11') }], style: { marginBottom: '0px' } },
                    React.createElement(Input, { allowClear: allowClearByMoblie, onBlur: () => {
                            allowClearByMoblie && setAllowClearByMoblie(false);
                        }, onFocus: () => {
                            !allowClearByMoblie && setAllowClearByMoblie(true);
                        }, placeholder: getIn18Text('QINGSHURULIANXI11') }))))));
};
export default UpgradeMeansModal;
